import React, { useEffect } from 'react';
import { gql, useQuery } from "@apollo/client";

import { useAppState } from "../../contexts/AppContext";

const MinPasswordLength: React.FC = () => {
    const [, setAppState] = useAppState();

    const { data } = useQuery(GET_MIN_PASSWORD_LENGTH);

    useEffect(() => {
        if (data?.minPasswordLength) {
            setAppState({ minPasswordLength: data.minPasswordLength });
        }
    }, [data, setAppState]);

    return null;
};

const GET_MIN_PASSWORD_LENGTH = gql`
    query minPasswordLength {
        minPasswordLength
    }
`;

export default MinPasswordLength;
